import * as io from "io-ts";
import { Column, Identifier } from "diagnostics-domain/dashboard/type";
export const FaultResource = io.strict({
  kind: io.literal("FAULT"),
  identifier: Identifier,
  column: Column,
  quantity: io.union([Identifier, io.undefined]),
});

export type FaultResourceT = io.TypeOf<typeof FaultResource>;
